export default __webpack_public_path__ + "static/media/target_audience.ea8604d3.jpg";